// The broadcast-cadence cap pair (per day / per week), used by both
// TenantCreate and TenantEditDrawer. Thin wrapper over the shared CapField —
// null = unlimited on that window.
//
// These are HARD caps enforced by the broadcast worker. The soft 7-day nudge
// is advisory-only and never blocks, so it is not mentioned here.

import { CapField } from './CapField.js'

interface Props {
  perDay: number | null
  perWeek: number | null
  onPerDayChange: (v: number | null) => void
  onPerWeekChange: (v: number | null) => void
}

export function BroadcastCadenceFields({
  perDay,
  perWeek,
  onPerDayChange,
  onPerWeekChange,
}: Props) {
  return (
    <>
      <CapField
        id="max_broadcasts_per_day"
        label="Broadcasts per day"
        hint="Hard cap on broadcasts in a 24-hour rolling window. Unlimited = no daily cap."
        value={perDay}
        onChange={onPerDayChange}
        min={0}
        max={100}
        fallbackOnUncheck={3}
      />
      <CapField
        id="max_broadcasts_per_week"
        label="Broadcasts per week"
        hint="Hard cap on broadcasts in a 7-day rolling window. Unlimited = no weekly cap."
        value={perWeek}
        onChange={onPerWeekChange}
        min={0}
        max={1000}
        fallbackOnUncheck={7}
      />
    </>
  )
}
